import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import DateTimeBase from "components/common/DateTime";

@autobind
/**
 *
 */
export default class DateTime extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @return {XML}
   */
  get _component() {
    return <DateTimeBase onChange={(value) => this.props.onChange(app.transform.fa2en(value))} />;
  }
}
